<template>
  <div>
    <Pane :bottom="0" :showRemarks="false">
      <a-tabs :tabBarStyle="{
        margin: '0',
      }" v-model="activeIndex">
        <a-tab-pane v-for="(item, index) in [{ name: '规范标准知识' }, { name: '公司行政知识' }]" :key="index" :tab="item.name">
        </a-tab-pane>
      </a-tabs>
    </Pane>

    <a-card class="container" v-if="activeIndex == 0">
      <a-row>
        <a-col :span="20">
          <a-form-model :colon="false" :model="form" layout="inline" @keyup.enter.native="query1">
            <a-form-model-item>
              <a-input v-model="form.standardName" style="width: 150px" placeholder="标准名称" />
            </a-form-model-item>
            <a-form-model-item>
              <a-select
                v-model="form.type"
                placeholder="标准分类"
                show-search
                :filter-option="$selectFilterOption"
                style="width: 150px"
              >
                <a-select-option
                  v-for="item in typeList"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-model-item>

            <a-form-model-item>
              <a-select
                v-model="form.statusStd"
                placeholder="标准状态"
                show-search
                :filter-option="$selectFilterOption"
                style="width: 150px"
              >
                <a-select-option
                  v-for="item in statusStdList"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-model-item>

            <a-form-model-item>
              <a-select
                v-model="form.statusKb"
                placeholder="知识库状态"
                show-search
                :filter-option="$selectFilterOption"
                style="width: 150px"
              >
                <a-select-option
                  v-for="item in statusKbList"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
            
            <a-form-model-item>
              <a-space>
                <a-button @click="query1" type="primary">查询</a-button>
                <a-button @click="reset1">重置</a-button>
              </a-space>
            </a-form-model-item>
          </a-form-model>
        </a-col>
        <a-col :span="4">
          <div class="right" style="margin-top: 4px">
            <a-space>
              <a-button
                type="primary"
                v-if="$getPermission($route.path + '/add1')"
                @click="$router.push($route.path + '/add1')"
              >新增</a-button>
            </a-space>
          </div>
        </a-col>
      </a-row>

      <Padding />
    
      <a-table
        bordered
        :data-source="list"
        :loading="loading"
        @change="onChange1"
        :pagination="{
          total: total,
          current: current,
          pageSize: pageSize,
          showTotal: (total) => `共 ${total} 条记录`,
        }"
        rowKey="id"
      >
        <a-table-column title="标准名称" data-index="standardName"></a-table-column>
        <a-table-column title="标准分类" width="200px" align="center">
          <template slot-scope="text">
            <DataDictFinder
                dictType="kb_doc_dict.kb_doc_standard_types"
                :dictValue="text.type"
              />
          </template>
        </a-table-column>
       
        <a-table-column title="实施日期" data-index="implementationDate" width="160px" align="center"></a-table-column>
        <a-table-column title="废止日期" data-index="abolishDate" width="160px" align="center"></a-table-column>
        <a-table-column title="标准状态" width="100px" align="center">
          <template slot-scope="text">
            <DataDictFinder
                dictType="kb_doc_dict.kb_doc_status"
                :dictValue="text.statusStd"
              />
          </template>
        </a-table-column>
        <a-table-column title="更新日期" data-index="updateAt" width="160px" align="center"></a-table-column>
        <a-table-column title="知识库状态" width="100px" align="center">
          <template slot-scope="text">
            <DataDictFinder
                dictType="kb_doc_dict.kb_status"
                :dictValue="text.statusKb"
                iconType="badge"
                badgeType="color"
              />
          </template>
        </a-table-column>

        <a-table-column title="操作" align="center" width="140px">
          <template slot-scope="text">
            <a-space>
              <a
                href="#"
                v-if="$getPermission($route.path + '/edit1')"
                @click.prevent="
                  $router.push(`${$route.path}/edit1?id=${text.id}`)
                "
              >
                编辑
              </a>
              <a
                href="#"
                v-if="$getPermission($route.path + '/detail1')"
                @click.prevent="
                  $router.push(`${$route.path}/detail1?id=${text.id}`)
                "
              >
                查看
              </a>
              <a
                href="#"
                v-if="$getPermission($route.path + '/edit1')"
                @click.prevent="deleteRow1(text)"
                class="danger"
                >删除</a
              >
            </a-space>
          </template>
        </a-table-column>
      </a-table>
    </a-card>
    <a-card class="container" v-if="activeIndex == 1">
      <a-row>
        <a-col :span="20">
          <a-form-model :colon="false" :model="form" layout="inline" @keyup.enter.native="query1">
            <a-form-model-item>
              <a-input v-model="form.standardName" style="width: 150px" placeholder="制度文档名称" />
            </a-form-model-item>
            <a-form-model-item>
              <a-select
                v-model="form.department"
                placeholder="发文部门"
                show-search
                :filter-option="$selectFilterOption"
                style="width: 150px"
              >
                <a-select-option
                  v-for="item in productionDepartmentList"
                  :key="item.id"
                  :value="item.uniqueName"
                >
                  {{
                  item.uniqueName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item>
              <a-select
                v-model="form.statusStd"
                placeholder="制度状态"
                show-search
                :filter-option="$selectFilterOption"
                style="width: 150px"
              >
                <a-select-option
                  v-for="item in statusStdList"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-model-item>

            <a-form-model-item>
              <a-select
                v-model="form.statusKb"
                placeholder="知识库状态"
                show-search
                :filter-option="$selectFilterOption"
                style="width: 150px"
              >
                <a-select-option
                  v-for="item in statusKbList"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
            
            <a-form-model-item>
              <a-space>
                <a-button @click="query2" type="primary">查询</a-button>
                <a-button @click="reset2">重置</a-button>
              </a-space>
            </a-form-model-item>
          </a-form-model>
        </a-col>
        <a-col :span="4">
          <div class="right" style="margin-top: 4px">
            <a-space>
              <a-button
                type="primary"
                v-if="$getPermission($route.path + '/add2')"
                @click="$router.push($route.path + '/add2')"
              >新增</a-button>
            </a-space>
          </div>
        </a-col>
      </a-row>

      <Padding />

      <a-table
        bordered
        :data-source="list2"
        :loading="loading"
        @change="onChange2"
        :pagination="{
          total: total2,
          current: current2,
          pageSize: pageSize2,
          showTotal: (total) => `共 ${total} 条记录`,
        }"
        rowKey="id"
      >
        <a-table-column title="制度文档名称" data-index="adminName"></a-table-column>
        <a-table-column title="发文部门" data-index="department"></a-table-column>
       
        <a-table-column title="实施日期" data-index="implementationDate" width="160px" align="center"></a-table-column>
        <a-table-column title="废止日期" data-index="abolishDate" width="160px" align="center"></a-table-column>
        <a-table-column title="制度状态" width="100px" align="center">
          <template slot-scope="text">
            <DataDictFinder
                dictType="kb_doc_dict.kb_doc_status"
                :dictValue="text.statusStd"
              />
          </template>
        </a-table-column>
        <a-table-column title="更新日期" data-index="updateAt" width="160px" align="center"></a-table-column>
        <a-table-column title="知识库状态" width="100px" align="center">
          <template slot-scope="text">
            <DataDictFinder
                dictType="kb_doc_dict.kb_status"
                :dictValue="text.statusKb"
                iconType="badge"
                badgeType="color"
              />
          </template>
        </a-table-column>

        <a-table-column title="操作" align="center" width="140px">
          <template slot-scope="text">
            <a-space>
              <a
                href="#"
                v-if="$getPermission($route.path + '/edit2')"
                @click.prevent="
                  $router.push(`${$route.path}/edit2?id=${text.id}`)
                "
              >
                编辑
              </a>
              <a
                href="#"
                v-if="$getPermission($route.path + '/detail2')"
                @click.prevent="
                  $router.push(`${$route.path}/detail2?id=${text.id}`)
                "
              >
                查看
              </a>
              <a
                href="#"
                v-if="$getPermission($route.path + '/edit2')"
                @click.prevent="deleteRow2(text)"
                class="danger"
                >删除</a
              >
            </a-space>
          </template>
        </a-table-column>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import organization from "@/mixins/organization";
import EmployeeSelector from "@/components/employee-selector";
import watermark from "@/mixins/watermark";
import request from "@/api/request";
import study from "@/mixins/study";
import download from '@/api/download'
import { mapGetters } from "vuex";
import { saveAs } from "file-saver";
function fetchList1(data) {
  return request({
    url: "/ai-service/kbdocument/standard/list",
    method: "post",
    data
  });
}
function remove(id) {
  return request({
    url: `/ai-service/kbdocument/standard/${id}`,
    method: "delete"
  });
}
function fetchList2(data) {
  return request({
    url: "/ai-service/kbdocument/admin/list",
    method: "post",
    data
  });
}
function remove2(id) {
  return request({
    url: `/ai-service/kbdocument/admin/${id}`,
    method: "delete"
  });
}

export default {
  mixins: [watermark, study, organization],
  components: {
    EmployeeSelector,
  },
  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    typeList() {
      return this.findDataDict("kb_doc_dict.kb_doc_standard_types");
    },
    statusStdList() {
      return this.findDataDict("kb_doc_dict.kb_doc_status");
    },
    statusKbList() {
      return this.findDataDict("kb_doc_dict.kb_status");
    },
  },
  data() {
    return {
      activeIndex: 0,
      master: {},
      form: {},

      loading: false,
      list: [],
      total: 0,
      current: 1,
      pageSize: 10,
      
      list2: [],
      total2: 0,
      current2: 1,
      pageSize2: 10
    };
  },

  mounted() {
    this.getList1();
    this.getList2();
  },

  methods: {

    getList1() {
      this.loading = true;
      let startDate, endDate;
      const date  = this.form.date;
      if (Array.isArray(date) && date.length === 2) {
        startDate = date[0].format("YYYY-MM-DD");
        endDate = date[1].format("YYYY-MM-DD");
      }
      fetchList1({
        pageNum: this.current,
        pageSize: this.pageSize,
        standardName: this.form.standardName,
        type: this.form.type,
        statusStd: this.form.statusStd,
        statusKb: this.form.statusKb,
      })
        .then(res => {
          if (Array.isArray(res.list)) {
            this.list = res.list;
            this.total = res.totalSize || 0;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onChange1(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList1();
    },

    query1() {
      this.current = 1;
      this.getList1();
    },
    reset1() {
      this.current = 1;
      this.form = {};
      this.master = {};
      this.getList1();
    },

    deleteRow1(text) {
      const that = this;
      this.$confirm({
        title: "确认要删除吗？",
        onOk() {
          remove(text.id).then(() => {
            that.getList1();
          });
        },
      });
    },
    getList2() {
      this.loading = true;
      let startDate, endDate;
      const date  = this.form.date;
      if (Array.isArray(date) && date.length === 2) {
        startDate = date[0].format("YYYY-MM-DD");
        endDate = date[1].format("YYYY-MM-DD");
      }
      fetchList2({
        pageNum: this.current2,
        pageSize: this.pageSize2,
        standardName: this.form.standardName,
        department: this.form.department,
        statusStd: this.form.statusStd,
        statusKb: this.form.statusKb,
      })
        .then(res => {
          if (Array.isArray(res.list)) {
            this.list2 = res.list;
            this.total2 = res.totalSize || 0;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onChange2(pagination) {
      this.current2 = pagination.current;
      this.pageSize2 = pagination.pageSize;
      this.getList2();
    },

    query2() {
      this.current2 = 1;
      this.getList2();
    },
    reset2() {
      this.current2 = 1;
      this.form = {};
      this.master = {};
      this.getList2();
    },
    deleteRow2(text) {
      const that = this;
      this.$confirm({
        title: "确认要删除吗？",
        onOk() {
          remove2(text.id).then(() => {
            that.getList2();
          });
        },
      });
    },
  }
};
</script>
